import { useEffect, useState } from "react";
import { APIURL } from "../../configApi/apiConfig";
import axios from "../../configApi/axiosConfig";

const getCboRiesgo = () => axios.get(APIURL.get_CboRiesgo());
const getCboAcciones = () => axios.get(APIURL.get_CboAcciones());
const getCboCanales = () => axios.get(APIURL.get_CboCanales());
const getCboContactos = () => axios.get(APIURL.get_CboContactos());
const getCboResultados = () => axios.get(APIURL.get_CboResultados());
const getArbolGestion = () => axios.get(APIURL.get_CboArbolGestion())
const getSiguienteGestiones = () => axios.get(APIURL.get_CboSiguienteGestion())
const getEtapasGestion = () => axios.get(APIURL.get_CboEtapasGestion())
const getFactoresComportamiento = () => axios.get(APIURL.get_FactoresComportamiento())
const getCboEstrategias = () => axios.get(APIURL.get_CboEstrategias())
const getCboEstrategiasDetalle = () => axios.get(APIURL.get_CboEstrategiasDetalle());
const getCboScoringVariables = () => axios.get(APIURL.get_CboScoringVariables());
const getCboScoringPesos = () => axios.get(APIURL.get_CboScoringPesos());
const getCboScoringRangos = () => axios.get(APIURL.get_CboScoringRangos());
const getCboConfigComportamiento = () => axios.get(APIURL.get_CboConfigComportamiento());

//custom hook gets
export const useGetsCobranzas = () => {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const [riesgo, setRiesgo] = useState([]);
	const [acciones, setAcciones] = useState([]);
	const [canales, setCanales] = useState([]);
	const [contactos, setContactos] = useState([]);
	const [resultados, setResultados] = useState([]);
	const [arbol, setArbol] = useState([]);
	const [siguiente, setSiguiente] = useState([]);
	const [etapas, setEtapas] = useState([]);
	const [factores, setFactores] = useState([]);
	const [estrategias, setEstrategias] = useState([]);
	const [estrategiasDet, setEstrategiasDet] = useState([])
	const [scoringVar, setScoringVar] = useState([])
	const [scoringPes, setScoringPes] = useState([])
	const [scoringRan, setScoringRan] = useState([])
	const [configComp, setConfigComp] = useState([])


	const fetchData = async () => {
		try {
			setLoading(true);

			const [r, a, c, co, re, ar, sig, e, f, es, esdt, scv, scp,scr, ccom] = await Promise.all([
				getCboRiesgo(),
				getCboAcciones(),
				getCboCanales(),
				getCboContactos(),
				getCboResultados(),
				getArbolGestion(),
				getSiguienteGestiones(),
				getEtapasGestion(),
				getFactoresComportamiento(),
				getCboEstrategias(),
				getCboEstrategiasDetalle(),
				getCboScoringVariables(),
				getCboScoringPesos(),
				getCboScoringRangos(),
				getCboConfigComportamiento(),
			]);

			setRiesgo(r.data);
			setAcciones(a.data);
			setCanales(c.data);
			setContactos(co.data);
			setResultados(re.data);
			setArbol(ar.data);
			setSiguiente(sig.data);
			setEtapas(e.data);
			setFactores(f.data);
			setEstrategias(es.data);
			setEstrategiasDet(esdt.data)
			setScoringVar(scv.data)
			setScoringPes(scp.data)
			setScoringRan(scr.data)
			setConfigComp(ccom.data)

		} catch (err) {
			setError(err);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	return { riesgo, acciones, canales, contactos, resultados, arbol, siguiente, etapas, factores, estrategias, estrategiasDet, scoringVar, scoringPes, scoringRan, configComp, loading, error, refetch: fetchData };
};

/* updates */


export const patchCboRiesgo = async (id, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboRiesgo(id), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboAcciones = async (sCbo_Acciones, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboAcciones(sCbo_Acciones), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboCanales = async (sCbo_Canales, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboCanales(sCbo_Canales), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboContactos = async (sCbo_Contactos, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboContactos(sCbo_Contactos), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboResultados = async (sCbo_Resultados, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboResultados(sCbo_Resultados), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboArbolGestion = async (sCbo_ArbolGestion, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboArbolGestion(sCbo_ArbolGestion), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboSiguienteGestion = async (sCbo_SiguienteGestion, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboSiguienteGestion(sCbo_SiguienteGestion), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando CboSiguienteGestion", error);
		throw error;
	}
};

export const patchCboEtapa = async (sCbo_Etapas, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboEtapasGestion(sCbo_Etapas), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando Cbo_Etapas", error);
		throw error;
	}
};

export const patchCboFactoresComportamiento = async (sCbo_FactoresComportamiento, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboFactoresComportamiento(sCbo_FactoresComportamiento), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboEstrategias = async (sCbo_Estrategias, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboEstrategias(sCbo_Estrategias), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboEstrategiasDetalle = async (sCbo_EstrategiasDetalle, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboEstrategiasDetalle(sCbo_EstrategiasDetalle), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboScoringVariables = async (SCbo_ScoringVariables, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboScoringVariables(SCbo_ScoringVariables), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboScoringPesos = async (sCbo_ScoringPesos, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboScoringPesos(sCbo_ScoringPesos), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboScoringRangos = async (sCbo_ScoringRangos, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboScoringRangos(sCbo_ScoringRangos), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};

export const patchCboconfigComportamiento = async (sCbo_ConfigComportamiento, data) => {
	try {
		const response = await axios.patch(APIURL.patch_CboConfigComportamiento(sCbo_ConfigComportamiento), {
			...data,
		});
		return response.data;
	} catch (error) {
		console.error("Error actualizando resultado", error);
		throw error;
	}
};


/* posts */

export const postCboRiesgo = async (data) => {
	try {
		const url = APIURL.post_CboRiesgo();

		await axios.post(url, {
			Riesgo: data.Riesgo
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);

	}
};

export const postCboAcciones = async (data) => {
	try {
		const url = APIURL.post_CboAcciones();

		await axios.post(url, {
			Accion: data.Accion,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);

	}
};

export const postCboCanales = async (data) => {
	try {
		const url = APIURL.post_CboCanales();

		await axios.post(url, {
			Canal: data.Canal,
			InternoExterno: Number(data.InternoExterno),
			Activo: true

		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);

	}
};

export const postCboContacto = async (data) => {
	try {
		const url = APIURL.post_CboContactos();

		await axios.post(url, {
			Contacto: data.Contacto,
			Activo: true

		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);

	}
};

export const postCboResultado = async (data) => {
	try {
		const url = APIURL.post_CboResultados();

		await axios.post(url, {
			Resultado: data.Resultado,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboArboGestion = async (data) => {
	try {
		const url = APIURL.post_CboArbolGestion();

		await axios.post(url, {
			idCanal: data.idCanal,
			idContacto: data.idContacto,
			idResultado: data.idResultado,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboSiguienteGestion = async (data) => {
	try {
		const url = APIURL.post_CboSiguienteGestion();

		await axios.post(url, {
			idArbolGestion: Number(data.idArbolGestion),
			idAccion: data.idAccion,
			idCanal: data.idCanal,
			DiasProximaGestion: Number(data.DiasProximaGestion),
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboEtapasGestion = async (data) => {
	try {
		const url = APIURL.post_CboEtapasGestion();

		await axios.post(url, {
			Nombre: data.Nombre,
			MoraDesde: data.MoraDesde,
			MoraHasta: data.MoraHasta,
			Nivel: data.Nivel,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboFactoresComportamiento = async (data) => {
	try {
		const url = APIURL.post_CboFactoresComportamiento();

		await axios.post(url, {
			Nombre: data.Nombre,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboEstrategias = async (data) => {
	try {
		const url = APIURL.post_CboEstrategias();

		await axios.post(url, {
			idEtapa: data.idEtapa,
			idCbo_Riesgo: data.idCbo_Riesgo,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboEstrategiasDetalle = async (data) => {
	try {
		const url = APIURL.post_CboEstrategiasDetalle();

		await axios.post(url, {
			idEstrategia: data.idEstrategia,
			idAccion: data.idAccion,
			idCanal: data.idCanal ,
			FrecuenciaDias: data.FrecuenciaDias ,
			Intensidad: data.Intensidad ,
			DiaInicio: data.DiaInicio ,
			PrioridadBase: data.PrioridadBase ,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboScoringVariables = async (data) => {
	try {
		const url = APIURL.post_CboScoringVariables();

		await axios.post(url, {
			Codigo: data.Codigo,
			Nombre: data.Nombre,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response?.data || error.message);
	}
};

export const postCboScoringPesos = async (data) => {
	try {
		const url = APIURL.post_CboScoringPesos();

		await axios.post(url, {
			idVariable: data.idVariable,
			Peso: data.Peso,
			FechaInicio: data.FechaInicio,
			FechaFin: data.FechaFin,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response || error.message);
	}
};

export const postCboScoringRangos = async (data) => {
	try {
		const url = APIURL.post_CboScoringRangos();

		await axios.post(url, {
			idVariable: data.idVariable,
			ValorDesde: data.ValorDesde,
			ValorHasta: data.ValorHasta,
			ScoreAsignado: data.ScoreAsignado,
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response || error.message);
	}
};

export const postCboConfigComportamiento = async (data) => {
	try {
		const url = APIURL.post_CboConfigComportamiento();

		await axios.post(url, {
			idFactorComportamiento: data.idFactorComportamiento,
			ValorDesde: Number(data.ValorDesde),
			ValorHasta: Number(data.ValorHasta),
			ScoreImpacto: Number(data.ScoreImpacto),
			Activo: true
		});
	} catch (error) {
		console.error("Error al guardar los datos del cliente", error.response || error.message);
	}
};